export default __webpack_public_path__ + "static/media/google-ad-manager.fa5af926.svg";